import React from 'react'
import { useSelector } from 'react-redux'
import { orderBy } from 'lodash'

import SearchActionsGeneric from '../searchActionsGeneric'
import CustomFilters from './filters'
import CustomSort from './sort'

import trads from '../../intl/trads.json'

const SearchActions = ({currentFilters, searchContainer}) => {
  const lang = useSelector(state => state.lang)

  const renderFiltersPanel = () => {
    return (
      <div className="mt-9 lg:mt-0">
        <span className="text-label mb-4 hidden lg:block">{trads[lang].search.filterBy}</span>
        <CustomFilters
          lang={lang} 
          attribute='contentType'
          defaultRefinement={currentFilters}
          transformItems={items =>
            orderBy(items.map(item => ({
              ...item,
              label: trads[lang].search.contentTypes[item.label] ?trads[lang].search.contentTypes[item.label].replace('É', 'E') : `${item.label} - bug`,
            }) ), "label", "asc")
          }
        />
      </div>
    )
  }

  const renderSortingPanel = () => {
    return (
      <>
        <span className="text-label mb-3 hidden lg:block">{trads[lang].search.orderBy}</span>
        <CustomSort
          defaultRefinement={process.env.GATSBY_ALGOLIA_INDEX}
          items={[
            { value: process.env.GATSBY_ALGOLIA_INDEX, label: trads[lang].search.sorting.relevance },
            { value: process.env.GATSBY_ALGOLIA_INDEX_DESC, label: trads[lang].search.sorting.desc },
            { value: process.env.GATSBY_ALGOLIA_INDEX_ASC, label: trads[lang].search.sorting.asc },
          ]}
        />
      </>
    )
  }

  return (
    <SearchActionsGeneric
      filtersPanel={renderFiltersPanel()}
      sortingPanel={renderSortingPanel()}
      applyLabel={trads[lang].newsroom.apply}
      searchContainer={searchContainer} />
  )
}

export default SearchActions